import MatchType from "./MatchType";

export default class DataUtils {

    static TYPESTR = ['', '进球', '角球', '黄牌', '红牌', '界外球', '任意球', '球门球', '点球', '换人', '比赛开始', '中场', '结束', '半场比分', '两黄变红', '点球未进', '乌龙球', '伤停补时', '射正', '射偏', '进攻', '危险进攻', '控球率', '加时赛结束', '点球大战结束', 'VAR'];

    static getType(type) {
        return DataUtils.TYPESTR[type] ? DataUtils.TYPESTR[type] : '';
    }

    static getFootName(type) {
        if (type == 1) {
            return '左脚';
        } else if (type == 2) {
            return '右脚';
        } else if (type == 3) {
            return '左右脚';
        }
        return '未知';
    }

    static getPositionName(name, type) {
        if (type == MatchType.BASKETBALL) {
            if (name == 'F') {
                return '前锋';
            } else if (name == 'SF') {
                return '小前锋';
            } else if (name == 'PF') {
                return '大前锋';
            } else if (name == 'C') {
                return '中锋';
            } else if (name == 'G') {
                return '后卫';
            } else if (name == 'SG') {
                return '得分后卫';
            } else if (name == 'PG') {
                return '组织后卫';
            } else {
                return '其他';
            }
        } else if (type == MatchType.FOOTBALL) {
            if (name == 'F') {
                return '前锋';
            } else if (name == 'M') {
                return '中场';
            } else if (name == 'D') {
                return '后卫';
            } else if (name == 'G') {
                return '守门员';
            } else {
                return '其他';
            }
        }
        return '其他'
    }

    static getFootBallSkillList(data) {
        let skill = [];
        skill['比赛'] = [];
        skill['比赛'].push({ name: '出场', value: data.matches });
        skill['比赛'].push({ name: '首发', value: data.first });
        skill['比赛'].push({ name: '场均时间', value: (data.minutes_played / data.matches).toFixed(1) + '分钟' });

        skill['进球'] = [];
        skill['进球'].push({ name: '进球(点球)', value: data.goals + '/' + data.penalty });
        let val = (data.minutes_played / + data.goals).toFixed(1);
        skill['进球'].push({ name: '耗时/球', value: data.goals > 0 ? val + '分钟' : '未进球' });
        skill['进球'].push({ name: '场均射门', value: (data.shots / data.matches).toFixed(1) });
        skill['进球'].push({ name: '场均射正', value: (data.shots_on_target / data.matches).toFixed(1) });
        skill['进球'].push({ name: '助攻', value: data.assists });
        skill['进球'].push({ name: '场均助攻', value: (data.assists / data.matches).toFixed(1) });
        skill['进球'].push({ name: '场均关键传球', value: (data.key_passes / data.matches).toFixed(1) });

        skill['进球'].push({ name: '场均成功传球', value: (data.passes_accuracy / data.matches).toFixed(1) });
        skill['进球'].push({ name: '场均成功长传', value: (data.long_balls_accuracy / data.matches).toFixed(1) });
        skill['进球'].push({ name: '场均成功传中', value: (data.crosses_accuracy / data.matches).toFixed(1) });


        skill['防守'] = [];
        skill['防守'].push({ name: '场均抢断', value: (data.tackles / data.matches).toFixed(1) });
        skill['防守'].push({ name: '场均拦截', value: (data.interceptions / data.matches).toFixed(1) });
        skill['防守'].push({ name: '场均封堵', value: (data.blocked_shots / data.matches).toFixed(1) });
        skill['防守'].push({ name: '场均解围', value: (data.clearances / data.matches).toFixed(1) });


        skill['其他'] = [];
        skill['其他'].push({ name: '场均1对1成功', value: (data.duels_won / data.matches).toFixed(1) });
        skill['其他'].push({ name: '场均失误', value: (data.dispossessed / data.matches).toFixed(1) });
        skill['其他'].push({ name: '场均犯规', value: (data.fouls / data.matches).toFixed(1) });
        skill['其他'].push({ name: '场均被犯规', value: (data.was_fouled / data.matches).toFixed(1) });
        skill['其他'].push({ name: '黄牌', value: (data.yellow_cards / data.matches).toFixed(1) });
        skill['其他'].push({ name: '红牌', value: (data.red_cards / data.matches).toFixed(1) });

        return skill;
    }

    static getBasketBallSkillList(data) {
        let skill = [];
        skill['比赛'] = [];
        skill['比赛'].push({ name: '出场', value: data.matches });
        skill['比赛'].push({ name: '首发', value: data.first });
        skill['比赛'].push({ name: '场均时间', value: (data.minutes_played / data.matches).toFixed(1) + '分钟' });

        skill['得分'] = [];
        skill['得分'].push({ name: '场均得分/罚球', value: (data.point / data.matches).toFixed(1) + '分/' + (data.free_throws_scored / data.matches).toFixed(1) + '分' });
        skill['得分'].push({ name: '场均投篮', value: (data.field_goals_total / data.matches).toFixed(1) + '次' });
        skill['得分'].push({ name: '投篮命中率', value: data.field_goals_accuracy + "%" });
        skill['得分'].push({ name: '场均三分', value: (data.three_points_total / data.matches).toFixed(1) });
        skill['得分'].push({ name: '三分命中率', value: data.three_points_accuracy + "%" });
        skill['得分'].push({ name: '场均罚球', value: (data.free_throws_total / data.matches).toFixed(1) });
        skill['得分'].push({ name: '罚球命中率', value: data.free_throws_accuracy + "%" });


        skill['篮板'] = [];
        skill['篮板'].push({ name: '场均篮板', value: (data.rebounds / data.matches).toFixed(1) + '个' });
        skill['篮板'].push({ name: '场均拦截', value: (data.offensive_rebounds / data.matches).toFixed(1) + '个' });
        skill['篮板'].push({ name: '场均封堵', value: (data.defensive_rebounds / data.matches).toFixed(1) + '个' });
        return skill;
    }
}
